(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
      this.handleTitleClick = this.handleTitleClick.bind(this);
      this.handleTitleKeydown = this.handleTitleKeydown.bind(this);
      this.handleWindowResize = this.handleWindowResize.bind(this);
    }

    connectedCallback() {
      if (document.readyState === 'complete') {
        this.setStickyTopFromHeader();
      } else {
        window.addEventListener('load', () => this.setStickyTopFromHeader(), { once: true });
      }

      window.addEventListener('resize', this.handleWindowResize);

      this.titles = Array.from(this.querySelectorAll('[data-tab-target]'));
      this.panels = Array.from(this.querySelectorAll('.product-information-tabs__panel'));

      this.titles.forEach((title) => {
        title.addEventListener('click', this.handleTitleClick);
        title.addEventListener('keydown', this.handleTitleKeydown);

        const isActive = title.classList.contains('is-active');
        title.setAttribute('aria-selected', isActive ? 'true' : 'false');
        title.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    disconnectedCallback() {
      if (this.titles) {
        this.titles.forEach((title) => {
          title.removeEventListener('click', this.handleTitleClick);
          title.removeEventListener('keydown', this.handleTitleKeydown);
        });
      }

      window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize() {
      this.setStickyTopFromHeader();
    }

    setStickyTopFromHeader() {
      const shopifyHeader = document.querySelector('.shopify-section__header');
      if (!shopifyHeader) return;

      // 去掉 rect.top，直接用 offsetHeight
      const offset = shopifyHeader.offsetHeight;

      document.documentElement.style.setProperty(
        '--product-information-tabs-sticky-top',
        `${offset}px`
      );
      }

    handleTitleKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.handleTitleClick(event);
      }
    }

    getStickyOffset() {
      const shopifyHeader = document.querySelector('.shopify-section__header');
      if (!shopifyHeader) return 0;

      return shopifyHeader.offsetHeight;
    }

    scrollToTabsHeader() {
      const tabsHeader = this.querySelector('.product-information-tabs__header');
      if (!tabsHeader) return;

      const stickyOffset = this.getStickyOffset();
      const rect = tabsHeader.getBoundingClientRect();
      const targetTop = window.scrollY + rect.top - stickyOffset;

      const doScroll = () => {
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth',
        });
      };

      if (document.startViewTransition) {
        document.startViewTransition(doScroll);
      } else {
        doScroll();
      }
    }

    handleTitleClick(event) {
      const target = event.currentTarget;
      const controlsId = target.getAttribute('aria-controls');
      if (!controlsId) return;
      // console.log('this.titles', this.titles, controlsId)
      // const activePanel = this.querySelector(`#${controlsId}`);
      const activePanel = document.getElementById(controlsId);
      // console.log('activePanel', activePanel)
      if (!activePanel) return;

      this.titles.forEach((title) => {
        const isActive = title === target;
        title.classList.toggle('is-active', isActive);
        title.setAttribute('aria-selected', isActive ? 'true' : 'false');
        title.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel === activePanel;
        panel.classList.toggle('is-active', isActive);
        panel.style.display = isActive ? 'block' : '';
      });

      // 处理不在 tabs-component 内的 panel（如 Reviews）
      if (activePanel && !this.panels.includes(activePanel)) {
        activePanel.style.display = 'block';
      }

      // 隐藏其他不在 this.panels 里的 panel
      this.titles.forEach((title) => {
        if (title !== target) {
          const otherId = title.getAttribute('aria-controls');
          const otherPanel = document.getElementById(otherId);
          if (otherPanel && !this.panels.includes(otherPanel)) {
            otherPanel.style.display = 'none';
          }
        }
      });

      this.scrollToTabsHeader();
    }
  }

  if (!customElements.get('tabs-component')) {
    customElements.define('tabs-component', TabsComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
